import React, { useState, useCallback } from "react";
import { Link, graphql } from "gatsby";
import Seo from "../components/seo";
import Layout from "../components/layout/layout";
import { BlogCateroyMeta } from "../data/metaData";
import { Col, Container, Row, Image } from "react-bootstrap";
import { GatsbyImage, getImage } from "gatsby-plugin-image";
import { AuthorDefault } from "../utils/imageConst";

export const Head = ({ pageContext: { category } }) => {
  return (
    <Seo
      title={category + " - " + BlogCateroyMeta.metaTitle}
      description={category + " - " + BlogCateroyMeta.metaDescription}
      ogImage={BlogCateroyMeta.ogImage}
      twitterImage={BlogCateroyMeta.twitterImage}
    />
  )
}

const CategoryList = ({ pageContext: { category }, data }) => {



  const [maxRange, setMaxRange] = useState(9);

  const Posts = data.allMdx.edges;
  const allPostLnth = Posts.length;
  const isMorePost = maxRange < allPostLnth;

  const handleLoadMore = useCallback(() => {
    setMaxRange(prevRange => prevRange + 9);
  }, [])

  return (
    <>
      <Layout>
        <section className="section  background-pattern">
          <Container className="py-5 mt-lg-5">
            <div className="banner-content text-center py-lg-5">
              <h1 className="title mb-0">
                {category}
              </h1>
            </div>
          </Container>
        </section>
        <section className="section bg-light">
          <Container className="py-5">
            <Row xs={1} lg={3} className="g-4">
              {Posts.slice(0, maxRange).map(({ node, index }) => {
                const imageBlog = getImage(node.frontmatter.featured);

                const author = node.frontmatter?.author;
                const siteinfo = data.site?.siteMetadata;
                const imageAuth = getImage(author?.img);

                return (
                  <Col key={index}>
                    <div className="card blog-list-card" key={node.frontmatter.title}>
                      <div className="blog-image">
                        <Link to={`${node.fields.slug}`} itemProp="url">
                          <GatsbyImage loading="lazy" image={imageBlog} width={384} height={226} alt="featured" />
                        </Link>
                      </div>
                      <div className="blog-list-content">
                        <div className="article">
                          <div className="single-line-meta author-top d-flex align-items-center mb-3">
                            <div className="author-image me-3">
                              {author?.img ? (
                                <GatsbyImage loading="lazy" className="bio-avatar" image={imageAuth} width={30} height={30} alt="author-profile" />
                              ) : (<Image loading="lazy" className="bio-avatar lazyload" src={AuthorDefault} width={30} height={30} alt="author-profile" />)}
                            </div>
                            <div className="author-content">
                              <p className="author-name font-size-12 mb-0">
                                {author?.name ? author?.name : siteinfo?.author}
                              </p>
                            </div>
                            <span className="inline-sep mx-1">|</span>
                            <p className="mb-0 font-size-12">{node.frontmatter.modifyDate}</p>
                          </div>
                          <h2 className="blog-title h4 mb-3"><Link to={`${node.fields.slug}`} itemProp="url"><span itemProp="headline">{node.frontmatter.title}</span></Link></h2>

                          <p className="blog-content mb-3" dangerouslySetInnerHTML={{
                            __html: node.frontmatter.description || node.excerpt,
                          }} itemProp="description" />
                          <div className="mt-auto">
                            <Link to={node.fields.slug} itemProp="url" className="btn btn-link btn-sm px-0">
                              <span>Read More</span> <i className="icon ms-2 zmdi zmdi-hc-lg zmdi-long-arrow-right"></i>
                            </Link>
                          </div>
                        </div>
                        <div className="article-footer">
                          <div className="d-flex align-items-center single-line-meta">
                            <p className="font-size-12 mb-0">
                              <span className="category text-primary">{category}</span>
                            </p>
                            <span className="inline-sep mx-1">|</span>
                            <p className="font-size-12 mb-0">
                              {node?.fields?.timeToRead?.text}
                            </p>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Col>
                )
              })}
            </Row>
            {isMorePost ? (
              <Col lg={12} md={12} className="mt-5 text-center">
                <button onClick={handleLoadMore} className="btn btn-lg btn-primary-theme-outline btn-240">Load More</button>
              </Col>
            ) : (
              <Col lg={12} md={12} className="mt-5 text-center">
                <p>No more results</p>
              </Col>
            )}
          </Container>
        </section>
      </Layout>
    </>
  );
}

export default CategoryList;

export const CategoryListQuery = graphql`
query CategoryList($category: String) {
  site {
    siteMetadata {
      author
    }
  }
  allMdx(
    sort: {frontmatter: {modifyDate: DESC}}
    filter: {frontmatter: {categories: {eq: $category}}}
  ) {
    edges {
      node {
        fields {
          slug
          timeToRead {
            text
          }
        }
        excerpt(pruneLength: 250)
        frontmatter {
          title
          date(formatString: "MMMM DD, YYYY")
          modifyDate(formatString: "MMMM DD, YYYY")
          featured {
            childImageSharp {
              gatsbyImageData(width: 384)
            }
          }
          author {
            name
            img {
              childImageSharp {
                gatsbyImageData(width: 30)
              }
            }
          }
        }
      }
    }
  }
}`